import * as React from 'react';
import { ChromePicker } from 'react-color';
import { Popover } from 'react-tiny-popover';
import styled from 'styled-components';
import { styledWithProps } from 'utils';
import { getHexFromColor } from 'utils/PixiUtils';
import { ColorSwatches } from './ColorSwatches';

const Wrapper = styledWithProps<{ compact: boolean }>()(styled.div)`
  border-radius: ${p => (p.compact ? 0 : 4)}px;
  border: 1px solid #dadada;
  background-color: white;
  flex-grow: 1;

  .swatch {
    border: 1px solid rgba(var(--menu-fg-rgb), 0.1);
    height: ${p => (p.compact ? 12 : 20)}px;
    cursor: pointer;
  }
`;

interface Props {
  color: string;
  onChange: (color: string) => void;
  onBlur?: () => void;
  hideAlpha?: boolean;
  compact?: boolean;
}

export const ColorPicker: React.FC<Props> = ({
  color,
  onChange,
  onBlur,
  hideAlpha,
  compact
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const clickedInside = React.useRef(false);

  React.useEffect(() => {
    const onMouseDown = (e: MouseEvent) => {
      clickedInside.current = false;
      const picker = document.querySelector('.chrome-picker');
      if (picker && picker.contains(e.target as HTMLElement)) {
        clickedInside.current = true;
      }
    };
    // mount
    document.addEventListener('mousedown', onMouseDown);
    return () => {
      // ummount
      document.removeEventListener('mousedown', onMouseDown);
    };
  }, []);

  return (
    <Wrapper compact={compact ?? false}>
      <Popover
        isOpen={isOpen}
        positions={['bottom', 'top', 'right', 'left']} // preferred positions by priority
        onClickOutside={() => {
          if (clickedInside.current === true) {
            return;
          }
          onBlur?.();
          setIsOpen(false);
        }}
        align="start"
        reposition={true}
        content={
          <>
            <ChromePicker
              disableAlpha={hideAlpha ?? false}
              color={color}
              onChange={c => onChange(getHexFromColor(c))}
            />
            <ColorSwatches color={color} onChange={c => onChange(c)} />
          </>
        }
      >
        <div
          style={{ padding: `${compact ? 3 : 4}px`, cursor: 'pointer' }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="swatch" style={{ backgroundColor: color }} />
        </div>
      </Popover>
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/controller/components/ColorPicker.tsx